import { useQuery } from '@tanstack/react-query';
import { zohoApi } from '../services/api';

export function useZohoAccounts() {
  return useQuery({
    queryKey: ['zoho-accounts'],
    queryFn: () => zohoApi.accounts(),
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  });
}
